import React, {useContext, useState} from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  Avatar,
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  LinearProgress,
  Divider,
  Typography,
  makeStyles
} from '@material-ui/core';
import MusicianContext from 'src/musicianContext';
import { firebase } from 'src/db/db';
const storageRef = firebase.storage().ref();

const useStyles = makeStyles(() => ({
  root: {},
  avatar: {
    height: 100,
    width: 100
  }
}));

const Profile = ({ className, ...rest }, props) => {
  const classes = useStyles();
  const musician = useContext(MusicianContext);
  const [imageUploadProgress, setImageUploadProgress] = useState(null);

  const selectImage = () => {
    document.getElementById("logo").click();
  };
  
  const handleChange = e => {
    if(e.target.files[0]) {
      const image = e.target.files[0];
      const uploadTask = storageRef.child(`musicians/${musician.musician}/logo/${image.name}`).put(image)
      uploadTask.on(
          "state_changed",
          snapshot => {
              //progress function
              const progress = Math.round(
                  (snapshot.bytesTransferred / snapshot.totalBytes) * 100
              );
              setImageUploadProgress(progress)
          },
          error => {
              //Error function
              console.log(error);
          },
          () => {
            storageRef
                  .child(`musicians/${musician.musician}/logo/${image.name}`)
                  .getDownloadURL()
                  .then((url) => {
                      musician.setLogo(url);
                  });
          }
      );
    }
  };

  return (
    <Card className={clsx(classes.root, className)} {...rest}>
      <CardContent>
        <Box alignItems="center" display="flex" flexDirection="column">
          <Avatar className={classes.avatar} src={musician.logo} />
          <Typography color="textPrimary" gutterBottom variant="h3">
            {musician.user ? musician.user.displayName : "..."}
          </Typography>
          <Typography
            className={classes.dateText}
            color="textSecondary"
            variant="body1"
          >
            {`Artist Name: ${musician.musician}`}
          </Typography>
        </Box>
      </CardContent>
      <Divider />
      <CardActions>
        <Button color="primary" fullWidth variant="text" onClick={selectImage}>
          Upload picture
        </Button>
        <input id="logo" hidden style={{ opacity: 0 }} type="file" accept="image/*" onChange={handleChange} />
      </CardActions>
      <LinearProgress variant="determinate" value={imageUploadProgress} />
    </Card>
  );
};

Profile.propTypes = {
  className: PropTypes.string
};

export default Profile;
